import React from 'react';
import { MdClose, MdCheckCircle, MdError, MdWarning, MdInfo } from 'react-icons/md';

const OperationModal = ({ 
  isOpen, 
  onClose, 
  type = 'info', // 'success', 'error', 'warning', 'info'
  title, 
  message, 
  details = null,
  showProgress = false,
  progress = 0,
  onConfirm = null,
  onCancel = null,
  confirmText = 'OK',
  cancelText = 'Cancel',
  showCancel = false
}) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <MdCheckCircle size={48} style={{ color: '#28a745' }} />;
      case 'error':
        return <MdError size={48} style={{ color: '#dc3545' }} />;
      case 'warning':
        return <MdWarning size={48} style={{ color: '#ffc107' }} />;
      default:
        return <MdInfo size={48} style={{ color: '#17a2b8' }} />;
    }
  };

  const getBackgroundColor = () => {
    switch (type) {
      case 'success':
        return '#d4edda';
      case 'error':
        return '#f8d7da';
      case 'warning':
        return '#fff3cd';
      default:
        return '#d1ecf1';
    }
  };

  const getBorderColor = () => {
    switch (type) {
      case 'success':
        return '#c3e6cb';
      case 'error':
        return '#f5c6cb';
      case 'warning':
        return '#ffeaa7';
      default:
        return '#bee5eb';
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: 12,
        padding: 24,
        width: '90%',
        maxWidth: 500,
        maxHeight: '80vh',
        overflowY: 'auto',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
        position: 'relative',
      }}>
        {/* Close Button */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: 16,
            right: 16,
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 8,
            borderRadius: 4,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <MdClose size={24} style={{ color: '#666' }} />
        </button>

        {/* Content */}
        <div style={{
          textAlign: 'center',
          paddingRight: 40, // Space for close button
        }}>
          {/* Icon */}
          <div style={{ marginBottom: 16 }}>
            {getIcon()}
          </div>

          {/* Title */}
          <h2 style={{
            margin: '0 0 16px 0',
            color: '#333',
            fontSize: 20,
            fontWeight: 'bold',
          }}>
            {title}
          </h2>

          {/* Message */}
          <div style={{
            backgroundColor: getBackgroundColor(),
            border: `1px solid ${getBorderColor()}`,
            borderRadius: 8,
            padding: 16,
            marginBottom: 16,
          }}>
            <p style={{
              margin: 0,
              color: '#333',
              fontSize: 14,
              lineHeight: 1.5,
            }}>
              {message}
            </p>
          </div>

          {/* Details */}
          {details && (
            <div style={{
              backgroundColor: '#f8f9fa',
              border: '1px solid #e9ecef',
              borderRadius: 8,
              padding: 12,
              marginBottom: 16,
              textAlign: 'left',
            }}>
              <h4 style={{ margin: '0 0 8px 0', fontSize: 12, color: '#666', fontWeight: 'bold' }}>
                Details:
              </h4>
              <div style={{ fontSize: 12, color: '#333' }}>
                {typeof details === 'string' ? (
                  <p style={{ margin: 0 }}>{details}</p>
                ) : (
                  details
                )}
              </div>
            </div>
          )}

          {/* Progress Bar */}
          {showProgress && (
            <div style={{ marginBottom: 16 }}>
              <div style={{
                width: '100%',
                height: 8,
                backgroundColor: '#e9ecef',
                borderRadius: 4,
                overflow: 'hidden',
                marginBottom: 8,
              }}>
                <div style={{
                  width: `${progress}%`,
                  height: '100%',
                  backgroundColor: '#17a2b8',
                  transition: 'width 0.3s ease',
                }} />
              </div>
              <p style={{ margin: 0, fontSize: 12, color: '#666' }}>
                {progress}% Complete
              </p>
            </div>
          )}

          {/* Action Buttons */}
          <div style={{
            display: 'flex',
            gap: 12,
            justifyContent: 'center',
            marginTop: 20,
          }}>
            {showCancel && (
              <button
                onClick={onCancel || onClose}
                style={{
                  padding: '10px 20px',
                  border: '1px solid #6c757d',
                  borderRadius: 6,
                  backgroundColor: 'white',
                  color: '#6c757d',
                  cursor: 'pointer',
                  fontSize: 14,
                  fontWeight: 'bold',
                }}
              >
                {cancelText}
              </button>
            )}
            <button
              onClick={onConfirm || onClose}
              style={{
                padding: '10px 20px',
                border: 'none',
                borderRadius: 6,
                backgroundColor: type === 'error' ? '#dc3545' : '#17a2b8',
                color: 'white',
                cursor: 'pointer',
                fontSize: 14,
                fontWeight: 'bold',
              }}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OperationModal;
